export * from './IconCircled';
try {
    // @ts-ignore
    IconCircled.displayName = "IconCircled";
    // @ts-ignore
    IconCircled.__docgenInfo = { "description": "", "displayName": "IconCircled", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/IconCircled/index.ts#IconCircled"] = { docgenInfo: IconCircled.__docgenInfo, name: "IconCircled", path: "src/components/IconCircled/index.ts#IconCircled" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    IconCircledDocz.displayName = "IconCircledDocz";
    // @ts-ignore
    IconCircledDocz.__docgenInfo = { "description": "", "displayName": "IconCircledDocz", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/IconCircled/index.ts#IconCircledDocz"] = { docgenInfo: IconCircledDocz.__docgenInfo, name: "IconCircledDocz", path: "src/components/IconCircled/index.ts#IconCircledDocz" };
}
catch (__react_docgen_typescript_loader_error) { }